const updates = [
  {
    time: '10分钟前',
    title: '某女星工作室紧急发声明否认恋情传闻，称将追究造谣者法律责任',
    tag: '最新',
    tagColor: 'primary',
  },
  {
    time: '1小时前',
    title: '选秀节目制作方回应投票造假质疑：将配合第三方独立审计调查',
    tag: '跟进',
    tagColor: 'accent',
  },
  {
    time: '3小时前',
    title: '知名导演新片开机现场被曝与女主角不合，双方已互删社交动态',
    tag: '爆料',
    tagColor: 'primary',
  },
  {
    time: '6小时前',
    title: '某综艺节目未播片段意外流出，内容尺度引争议，节目组紧急回应',
    tag: '热议',
    tagColor: 'accent',
  },
  {
    time: '9小时前',
    title: '两大经纪公司公开互撕升级，多位艺人被迫站队表态，饭圈大战一触即发',
    tag: '持续',
    tagColor: 'secondary',
  },
  {
    time: '12小时前',
    title: '年度音乐盛典获奖名单提前泄露，多位入围歌手团队表示震惊与不满',
    tag: '独家',
    tagColor: 'primary',
  },
  {
    time: '昨天 20:30',
    title: '某男团成员被爆私联粉丝并索要礼物，经纪公司发声明称已内部调查',
    tag: '爆料',
    tagColor: 'primary',
  },
];

export default function Updates() {
  const getTagClasses = (color: string) => {
    switch (color) {
      case 'primary':
        return 'bg-primary-100 text-primary-700';
      case 'accent':
        return 'bg-accent-100 text-accent-700';
      default:
        return 'bg-secondary-100 text-secondary-700';
    }
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm">实时追踪 · 分秒必争的瓜料动态</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200/70 hidden md:block"></div>

          <div className="space-y-0">
            {updates.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                className="relative flex items-start gap-5 py-4 cursor-pointer group"
              >
                <div className="relative z-10 flex-shrink-0 hidden md:flex">
                  <div className="w-[38px] h-[38px] flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-200 group-hover:border-primary-400 group-hover:bg-primary-50 transition-colors">
                    <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                  </div>
                </div>

                <div className="flex-1 min-w-0 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 group-hover:border-primary-200 transition-colors">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span
                      className={`px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${getTagClasses(item.tagColor)}`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug font-heading">
                    {item.title}
                  </h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}